import { FormControl, Validators } from '@angular/forms';

export class AllocationRuleSelectionModel {
  ruleId: number = null;
  slotId: number = null;

  constructor(params?: AllocationRuleSelectionModel) {
    if (params) {
      this.ruleId = params.ruleId;
      this.slotId = params.slotId;
    }
  }
}

export class AllocationRuleSelectionFormModel {
  constructor(
    model: AllocationRuleSelectionModel,
    public ruleId: FormControl<number> = new FormControl(model.ruleId, [Validators.required]),
    public slotId: FormControl<number> = new FormControl(model.slotId, [Validators.required]),
  ) {}
}
